import { Color } from '../../../interface';
import { assignComponentProps } from '../../../utils/helpers';
import { getAppRoot } from '../../../utils/theme';

export interface ModalOpts {
  'color'?: Color;
  'autoHide'?: number;
  'message': string;
}

export async function createNotify(opts: ModalOpts): Promise<HTMLLarNotifyElement> {
  if (typeof customElements !== 'undefined') {
    await customElements.whenDefined('lar-notify');
    const element = document.createElement('lar-notify') as HTMLLarNotifyElement;
    assignComponentProps(element, opts);
      // append the overlay element to the document body
      // @TODO: re-position notify from top how manuy active notfy's there are
    getAppRoot(document).appendChild(element);
    if (element.componentOnReady) {
      await element.componentOnReady();
    }
    element.addEventListener('larnotifydiddismiss', () => {
        element.remove();
      })
    return element;
  }
  throw new Error('WebComponents not available');
};
